import { __awaiter } from "tslib";
import { callService } from "@phoenixreisen/gateway";
import { SessionStore } from "./fns.store";
export function getScrollOffset() {
    return (window.scrollY ||
        window.pageYOffset ||
        document.body.scrollTop +
            ((document.documentElement && document.documentElement.scrollTop) || 0));
}
export function getReferrer() {
    var _a, _b;
    const currentHref = location.href;
    const currentHost = location.host;
    const browserReferrer = (_a = document.referrer) !== null && _a !== void 0 ? _a : null;
    const explicitReferrer = (_b = SessionStore.get("referrer")) !== null && _b !== void 0 ? _b : null;
    if (explicitReferrer) {
        return explicitReferrer;
    }
    if (browserReferrer &&
        currentHref !== browserReferrer &&
        (browserReferrer === null || browserReferrer === void 0 ? void 0 : browserReferrer.includes(currentHost))) {
        return browserReferrer;
    }
    return null;
}
export function getNations() {
    return __awaiter(this, void 0, void 0, function* () {
        return callService("laender.nationen", {
            "remote-addr": "set by backend",
            type: "get-laender-infos",
        });
    });
}
export function getNumLists(jwt, date) {
    return __awaiter(this, void 0, void 0, function* () {
        return callService("dfb.nummernlisten-ermitteln", {
            "erstellungs-datum": date || null,
            jwt: jwt,
        }).then((result) => {
            var _a;
            return (_a = result === null || result === void 0 ? void 0 : result["nummernlisten"]) !== null && _a !== void 0 ? _a : null;
        });
    });
}
export function getNumList(filename, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        return callService("dfb.get-vorgaenge", {
            name: filename,
            jwt: jwt,
        }).then((result) => {
            var _a;
            return (_a = result === null || result === void 0 ? void 0 : result["nummernlisten-vorgaenge"]) !== null && _a !== void 0 ? _a : null;
        });
    });
}
export function buildWtmDirectLink(links, webtextName, app) {
    var _a, _b;
    const url = (_b = (_a = links.WORKSPACE.find((link) => link.id === "webtextverwaltung")) === null || _a === void 0 ? void 0 : _a.href) !== null && _b !== void 0 ? _b : null;
    if (!url) {
        throw new Error("WTM-URL nicht in Linkliste gefunden.");
    }
    return `${url}/#!/form/${webtextName}${app ? `/${app}` : ""}`;
}
